// 5.43.0 notes reader: split text into plain parts and links (http(s):// and www.), so links can be clickable
// without ever putting the text in as HTML. Trailing punctuation stays outside the link.
const LINK = /\b(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
const TRAIL = /[.,;:!?)\]}'"]+$/;

export function linkParts(text) {
  const s = String(text || '');
  const out = [];
  let last = 0;
  s.replace(LINK, (m, _g, at) => {
    let url = m;
    const t = url.match(TRAIL);
    if (t) url = url.slice(0, -t[0].length);
    if (at > last) out.push({ text: s.slice(last, at) });
    out.push({ text: url, href: url.toLowerCase().startsWith('www.') ? `https://${url}` : url });
    last = at + url.length;
    return m;
  });
  if (last < s.length) out.push({ text: s.slice(last) });
  return out;
}
